import { Pipe, PipeTransform } from '@angular/core';; import { DatePipe } from "@angular/common";

@Pipe({
    name: 'searchByProp',
    pure: true
})
export class SearchByProperyPipe implements PipeTransform {
    transform(items: any[], propName: string, propValue: string): any[] {
        // console.log(propName);
        // console.log(propValue);

        propValue = propValue.toLowerCase()
        if (!items) return [];
        else if (!propValue) return items;

        let filter_list = items.filter(it => {
            if (it[propName].toLowerCase().includes(propValue)) {
                return it;
            }
        });
        // console.log(filter_list);
        return filter_list;

    }
}
